module.exports = __webpack_public_path__ + "img/austria.d596800b.svg";